import { useCallback } from 'react'
import { MyEmpty } from '~/components/ui/MyEmpty'
import { MyBtn } from '~/components/ui/MyBtn'
import { MyModal } from '~/components/ui/MyModal'

/** 支付成功弹窗 */
const PaySuccessCard: React.FC<{
  visible: boolean
  setVisible: React.Dispatch<React.SetStateAction<boolean>>
}> = ({ visible, setVisible }) => {
  const goBack = useCallback(() => {
    setVisible(false)
    location.reload()
  }, [])

  return (
    <>
      <MyModal
        visible={visible}
        title="支付成功"
        onCancel={() => {
          goBack()
        }}
        maskStyle={{
          backgroundColor: 'rgba(0,0,0,0.8)',
        }}
        bodyStyle={{ maxHeight: 600, overflowY: 'auto' }}
        width={448}
        footer={null}
        dark
      >
        <MyEmpty
          image="/images/order/success.png"
          description="支付成功"
          className="!my-[100px]"
        />
        <MyBtn type="primary" className="w-[384px]" onClick={goBack}>
          确定
        </MyBtn>
      </MyModal>
    </>
  )
}

export default PaySuccessCard
